import { render, staticRenderFns } from "./TeamSection.vue?vue&type=template&id=1f76015e&scoped=true"
import script from "./TeamSection.vue?vue&type=script&lang=js"
export * from "./TeamSection.vue?vue&type=script&lang=js"
import style0 from "./TeamSection.vue?vue&type=style&index=0&id=1f76015e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76015e",
  null
  
)

export default component.exports